export const ANALYTIC_LDS_MODULE = 'llwShare';
export const ANALYTIC_SEGMENT = 'segment';
export const ANALYTIC_AUTH_USER_SESSION_ID = 'analyticsSessionId';

export const ANALYTICS_ACTION_TYPE = {
  CANCEL_BTN_CLICKED: 'cancelButtonClicked',
  CREATE_BTN_CLICKED: 'createButtonClicked',
  MANAGED_BTN_CLICKED: 'manageButtonClicked',
  STOP_SHARING_BTN_CLICKED: 'stopSharingButtonClicked',
} as const;
export type AnalyticsActionType = typeof ANALYTICS_ACTION_TYPE[keyof typeof ANALYTICS_ACTION_TYPE];

export const ANAYLTICS_TITLE_TYPE = {
  LDS_CODE_CREATED: 'lds_code_created',
  LDS_CODE_MANAGED: 'lds_code_managed',
  LDS_CODE_SHARING_STOPPED: 'lds_code_sharing_stopped',
  LDS_CODE_REMOVAL_ATTEMPTED: 'lds_code_removal_attempted',
} as const;
export type AnalyticsTitleType = typeof ANAYLTICS_TITLE_TYPE[keyof typeof ANAYLTICS_TITLE_TYPE];
